import Cookies from 'js-cookie'

export function useGetUser() {
  const getUser = Cookies.get('user')
  if (getUser) {
    const decode = JSON.parse(atob(getUser))
    return {
      user: { ...decode },
    }
  }
  return { user: null }
}
